// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"cb418b9e","122":"f2b2b73e","169":"c6e423a5","180":"45e463fc","226":"a24b1280","243":"77bda82f","331":"c2d165ba","389":"35c8b965","453":"490aaab7","615":"ac0d5821","752":"c0f38a96","780":"84b25651","795":"38bf4c72","900":"42019ef0","912":"8ecceb7c","930":"3ce4405b"}[chunkId] + ".chunk.js";
};